export default __webpack_public_path__ + "static/media/480_portfolio03-jp-web.5f571bdb.png";